import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { ToastyService } from '@cime/ngx-toasty';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-customs-certificate',
    templateUrl: './certificate-selection.component.html',
})
export class CertificateSelectionDialogComponent implements OnInit {
    @Input()
    availableCertificates;

    isBusy = false;
    selectedCertificate;

    selected: string[] = [];

    selectableSettings: SelectableSettings = {
        checkboxOnly: true,
        mode: 'single',
    };

    constructor(
        public activeModal: NgbActiveModal,
        private translateService: TranslateService,
        private toastyService: ToastyService
    ) {}

    ngOnInit() {
        this.availableCertificates.forEach((element) => {
            const thisExpirationDate = new Date(element.expirationDate);
            element.expirationDate = thisExpirationDate.getDate() + '.' + thisExpirationDate.getMonth() + '.' + thisExpirationDate.getFullYear();
            /*
            if (element.issuerName.includes('Fina'))
            {
                element.selected = true;
            }
            else
            {
                element.selected = false;
            }*/
        });
    }

    /* Store selected item serialNumber into selected[] */
    selectionCallback(context: RowArgs): string {
        return context.dataItem.serialNumber;
    }

    signXML() {
        this.selected.length === 0
            ? this.toastyService.error(this.translateService.instant('Certificate must be selected'))
            : this.activeModal.close(this.selected[0]);
    }
}
